import React from 'react';
import './index.css';
import SiderMenu from '@pages/Assembly/siderMenu';
import { Flex } from '@components';
import { Button, Table, Icon, InputNumber, Input, Modal, message } from 'antd';
import { mkbz } from "@pages/Assembly/siderMenu/menuObj";
import Hint from "@pages/SelfHelp/common/hint";
import Breadcrumb from '@pages/Assembly/Breadcrumb';
import TitleTop from '@pages/Assembly/titleTop';
import { createUuid, getLoginUser } from '@utils/NHCore';
import NHFetch from "../../../../utils/NHFetch";
import CommonTip from "../common";
import NextButton from '@pages/SelfHelp/common/nextIndex'

/** 参数标识配置常量 */
const CONFIG = {
    /** 入学须知倒计时秒数参数标识 */
    COUNTDOWN_CSZB: 'TSXY_YXWZ_RXXZDJS',
    /** 入学须知是否强制阅读参数标识 */
    FORCE_READ_CSZB: 'TSXY_YXWZ_RXXZSFQZYD',
    /** 强制阅读参数值：是 */
    FORCE_READ_YES: '是',
};

/**
 * 判断配置值是否表示"是"
 * 兼容多种存储形式：'是' / '1' / 'true' / true
 * @param {*} value — 配置值
 * @returns {boolean}
 */
const isValueYes = (value) => {
    if (value === undefined || value === null) return false;
    const str = String(value).trim().toLowerCase();
    return str === '是' || str === '1' || str === 'true' || str === 'yes';
};

const {confirm} = Modal;

export default class dormitory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mkbz: 'GD023',
            hjmc: '',
            operable: true,//是否显示环节
            isAllPay: true,
            xsssruYwxx: [],
            jgfsx:'',
            sfxsxz: true,//是否显示须知
            xznr: {},//须知内容
            countdown: 10, // 倒计时秒数（可用参数设置，默认设为10秒）
            timer: null, // 定时器实例，用于清除倒计时
            isForceRead: false, // 是否强制阅读模式
            hasScrolled: false, // 用户是否已发生滚动动作
            isConfigReady: false, // 配置是否加载完成（防止配置返回前用户提前点击）
        };
        /** 须知内容容器 ref */
        this.noticeRef = React.createRef();
    }

    componentDidMount() {
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        this.getUserCjById();
        this.getJgfsx();
        this.queryQztjAndYlhj();
        this.getRxksxzDetail();
    }

    componentWillUnmount() {
        // 清除倒计时定时器
        if (this.state.timer) {
            clearInterval(this.state.timer);
        }
        // 移除滚动事件监听，防止内存泄漏
        if (this.noticeRef.current) {
            this.noticeRef.current.removeEventListener('scroll', this.handleScroll);
        }
    }

    /**
     * 启动倒计时
     * 强制阅读模式下，若用户未发生滚动且内容需要滚动，则暂不启动
     */
    startCountdown = () => {
        const { isForceRead, hasScrolled } = this.state;
        // 强制阅读模式下，未发生滚动且内容需要滚动时不启动倒计时
        if (isForceRead && !hasScrolled && this.checkNeedScroll()) {
            return;
        }
        // 清除已有定时器（防止重复创建）
        if (this.state.timer) {
            clearInterval(this.state.timer);
        }
        // 创建新定时器，每秒更新倒计时
        const timer = setInterval(() => {
            this.setState(prevState => {
                // 倒计时结束：清除定时器 + 关闭须知
                if (prevState.countdown <= 1) {
                    clearInterval(timer);
                    return {
                        countdown: 0,
                        sfxsxz: false, // 自动关闭须知
                        timer: null
                    };
                }
                // 倒计时未结束：秒数减1
                return { countdown: prevState.countdown - 1 };
            });
        }, 1000);
        // 保存定时器实例到状态
        this.setState({ timer });
    };
    

    //查询前置条件和依赖环节
    queryQztjAndYlhj = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        if (!xsid) {
            this.setState({
                nonOperationalData: { nologin: true },
                operable: false,
            });
            return;
        }
        let zzbdhjid = this.getQueryString('pkid');
        NHFetch("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid })
            .then(res => {
                if (res && res.data) {
                    let kfsj = res.data['kfsj'];
                    let ylhj = res.data['ylhj'];
                    let qzhj = res.data['qzhj'];
                    this.setState({ nonOperationalData: res.data });
                    if (kfsj && kfsj['YXSJ'] != '1') {
                        this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        this.setState({ operable: false });
                    }
                }
            });
    }

    //查询学生入学教育考试成绩

    getUserCjById = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        const zzbdhjid = this.getUrlParams("pkid");
        const taskcsbz = "YXXT_RXJYKS_TASKID";
        const jgfcsbz = "YXXT_RXJYKS_JGF";
        NHFetch('/questionnaire/getUserCjById', 'GET', {
            zzbdhjid:zzbdhjid,
            taskcsbz:taskcsbz,
            jgfcsbz:jgfcsbz,
            xsid: xsid
        })
            .then(res => {
                if (res && res.data) {
                    this.setState({
                        xsssruYwxx: res.data
                    });
                    this.refs.siderMenu.reloadMenuList()
                }
            });
    };


    //环节pkid
    getQueryString = (name) => {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    }

    //获取url中传递的参数
    getUrlParams = (param) => {
        return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    };

    setMenuList = (menuList) => {
        let nextCount = 0;
        let bz = this.state.mkbz;
        menuList.map((elem, index) => {
            if (elem.HJDM == bz) {
                let hjmc = elem.HJMC;
                this.setState({ hjmc: hjmc })
                nextCount = index + 1;
                return;
            }
        });
        let menu = menuList[nextCount];
        if (menu) {
            let hjdm = menu.HJDM;
            if (hjdm.indexOf('GD') == 0) {
                let gdUrl = mkbz[hjdm];
                this.setState({
                    nextUrl: gdUrl,
                    search: 'pkid=' + menu.PKID,
                })
            } else if (hjdm.indexOf('ZDY') == 0) {
                let zdyUrl = "/customLink";
                this.setState({
                    nextUrl: zdyUrl,
                    search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX,
                })
            } else if(hjdm.indexOf('DCWJ')==0){
                let wjUrl  = "/customizeExamination";
                this.setState({
                    nextUrl:wjUrl,
                    search:'pkid='+menu.PKID+'&mkbz='+hjdm,
                })
            }
        } else {
            this.setState({
                nextUrl: '',
                search: '',
            })
        }
    }

    getJgfsx =()=>{
        let params = {csbz: "YXXT_RXJYKS_JGF"};
        NHFetch('/zzbdCommon/getCssz', 'GET', params)
            .then(res => {
                if (res && res.data) {
                    this.setState({
                        jgfsx:res.data
                    })
                } else {
                    message.error('未获取及格分数线，请联系管理员！');
                }
            });
    }
    /**
     * 获取倒计时秒数配置
     * @returns {Promise} 请求 Promise
     */
    getCountdown = () => {
        let params = { csbz: CONFIG.COUNTDOWN_CSZB };
        return NHFetch('/zzbdCommon/getCssz', 'GET', params)
            .then(res => {
                if (res && res.data) {
                    this.setState({
                        countdown: res.data
                    });
                }
            });
    };

    /**
     * 获取强制阅读配置
     * @returns {Promise} 请求 Promise
     */
    getForceReadConfig = () => {
        let params = { csbz: CONFIG.FORCE_READ_CSZB };
        return NHFetch('/zzbdCommon/getCssz', 'GET', params)
            .then(res => {
                const isForceRead = res && isValueYes(res.data);
                this.setState({ isForceRead });
            });
    };

    /**
     * 滚动事件监听处理
     * 首次检测到滚动动作后启动倒计时
     */
    handleScroll = () => {
        const { hasScrolled, isForceRead } = this.state;
        if (!isForceRead || hasScrolled) {
            return;
        }
        // setState 是异步的，必须在回调中执行 startCountdown，
        // 否则 startCountdown 读取到的 hasScrolled 仍是旧值 false
        this.setState({ hasScrolled: true }, () => {
            this.startCountdown();
        });
    };

    /**
     * 检测容器内容是否需要滚动才能看完
     * @returns {boolean} true 表示内容超出容器，需要滚动
     */
    checkNeedScroll = () => {
        const el = this.noticeRef.current;
        if (!el) return false;
        return el.scrollHeight > el.clientHeight;
    };

    startStudy =()=>{
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        const taskcsbz = "YXXT_RXJYKS_TASKID";
        const ksrkcsbz = "YXXT_KSRK_HBDX";
        let params = {ksrkcsbz: ksrkcsbz,taskcsbz: taskcsbz,xsid: xsid};
        NHFetch('/questionnaire/getKsrk', 'GET', params)
            .then(res => {
                if (res && res.data) {
                    if(res.data != "-1"){
                        window.open(res.data);
                        const getUserCjById = this.getUserCjById;

                        confirm({
                            title: '是否完成入学教育考试?',
                            okText: '已完成',
                            okType: 'success',
                            cancelText: '未完成',
                            onOk() {
                                getUserCjById(true);
                            },
                            onCancel() {
                                getUserCjById(true);
                            },
                        });
                    }else{
                        message.error('你没有参与考试资格，请联系管理员！');
                    }
                } else {
                    message.error('未获取考试入口，请联系管理员！');
                }
            });


    }

    /**
     * 获取入学考试须知详情
     * 强制阅读模式下需等待用户滚动后才启动倒计时；若内容过短无需滚动则自动启动
     */
    getRxksxzDetail = () => {
        NHFetch("/xxfb/getRxksxzDetail", "GET")
            .then(res => {
                if (res && res.data) {
                    this.setState({
                        sfxsxz: true,//是否显示须知
                        xznr: res.data,//须知内容
                        isConfigReady: false,//配置加载中，按钮默认禁用
                    }, () => {
                        // 并行获取倒计时配置和强制阅读配置，待两者都返回后再决定倒计时行为
                        Promise.all([this.getCountdown(), this.getForceReadConfig()])
                            .then(() => {
                                this.setState({ isConfigReady: true });
                                // DOM 渲染完成后检测强制阅读逻辑
                                setTimeout(() => {
                                    const { isForceRead } = this.state;
                                    if (isForceRead) {
                                        // 强制阅读模式下，若内容无需滚动则自动启动倒计时
                                        if (!this.checkNeedScroll()) {
                                            this.startCountdown();
                                        }
                                    } else {
                                        // 非强制阅读模式，立即启动倒计时
                                        this.startCountdown();
                                    }
                                }, 0);
                            })
                            .catch(() => {
                                // 配置请求失败时按非强制阅读处理，避免页面卡死
                                this.setState({ isConfigReady: true });
                                this.startCountdown();
                            });
                    });
                } else {
                    // 清除定时器
                    if (this.state.timer) {
                        clearInterval(this.state.timer);
                    }
                    this.setState({
                        sfxsxz: false,
                        timer: null
                    });
                }
            });
    };

    /**
     * 手动关闭须知
     * 强制阅读模式下倒计时未结束时禁止关闭
     */
    onChangeSfxsxz = () => {
        const { isForceRead, countdown } = this.state;
        // 强制阅读模式下，倒计时未结束前不允许手动关闭
        if (isForceRead && countdown > 0) {
            return;
        }
        // 清除定时器
        if (this.state.timer) {
            clearInterval(this.state.timer);
        }
        this.setState({
            sfxsxz: false,
            timer: null
        });
    };

    render() {
        const { xsssruYwxx, jgfsx, sfxsxz, xznr, isForceRead, hasScrolled, countdown, isConfigReady } = this.state;

        // 配置加载完成前或强制阅读模式下倒计时未结束时，按钮禁用
        const isButtonDisabled = !isConfigReady || (isForceRead && countdown > 0);
        // 强制阅读模式下尚未发生滚动且内容可能需要滚动时，显示提示
        const showScrollHint = isForceRead && !hasScrolled && !this.state.timer;

        const columns = [
            {
                title: '考试时间',
                dataIndex: 'START_TIME',
            },
            {
                title: '考试成绩',
                dataIndex: 'RESULT_SCORE',
            }
        ];

        return (
            <div styleName="page_buy">
                {this.state.operable ?
                sfxsxz ?<Flex className="w1180 mt-20" align="start">
                      <SiderMenu
                          ref={"siderMenu"}
                          setMenuList={this.setMenuList}
                          title="自助报到"
                          mkbz={this.state.mkbz}
                          /*       active={1}*/
                          menuType="自助报到"
                      />
                      <Flex.Item className="page_con_r">
                       <div styleName="top">
                            <div styleName="title">{xznr.tzbt}</div>
                        </div>
                        <div styleName="con notice-scroll-container" ref={this.noticeRef} onScroll={this.handleScroll}>
                            <div dangerouslySetInnerHTML={{__html:xznr.tznr}} ></div>
                        </div>
                        {showScrollHint && (
                            <div styleName="scroll-hint">请滚动阅读内容后，倒计时才开始</div>
                        )}
                        <div className="text-center mt-50">
                            <Button
                                onClick={this.onChangeSfxsxz}
                                type="primary"
                                className="ml-20"
                                htmlType="submit"
                                disabled={isButtonDisabled}
                            >
                                确认阅读
                                {/* 显示倒计时（格式：X秒后自动关闭） */}
                                {countdown > 0 && (
                                    <span style={{ marginLeft: 10 }}>
                                        （{countdown}秒后自动关闭）
                                    </span>
                                )}
                            </Button>
                        </div>
                      </Flex.Item>
                  </Flex> :
                    <Flex className="w1180 mt-20" align="start">
                        <SiderMenu
                            ref={"siderMenu"}
                            setMenuList={this.setMenuList}
                            title="自助报到"
                            mkbz={this.state.mkbz}
                            /*       active={1}*/
                            menuType="自助报到"
                        />
                        <Flex.Item className="page_con_r">
                            <Breadcrumb
                                noLine
                                list={[
                                    { name: '首页', url: '/index' },
                                    { name: '自助报到', url: '/register' },
                                    { name: this.state.hjmc }
                                ]}
                            />
                            <div className="box">
                                <Hint />
                                {this.state.jgfsx ?
                                <TitleTop title={this.state.hjmc+` （及格分数： `+this.state.jgfsx+` 分及以上）`} extra={false} />
                                :<TitleTop title={this.state.hjmc+` （未设置及格标准）`} extra={false} />}
                                <div className="p-sw">
                                    <Table
                                        bordered
                                        size="middle"
                                        pagination={false}
                                        columns={columns}
                                        dataSource={xsssruYwxx}
                                    />
                                    <div className="text-center mt-50">
                                        <Button onClick={this.startStudy}
                                                type="primary"
                                                className={"ml-20"}
                                                htmlType="submit">考试入口</Button>
                                        <NextButton nextUrl={this.state.nextUrl} before={this.checkNext}
                                                    search={this.state.search}/>
                                    </div>
                                </div>
                            </div>
                        </Flex.Item>
                    </Flex> 
                    : <CommonTip hjmc={"入学考试"} key={"GD023"} mkbz='GD023' nonOperationalData={this.state.nonOperationalData} />}
            </div>
        );
    }
}
